import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { INavigationItem, INavigationSection } from '@app/main/interfaces';
import { NavigationService } from '@app/main/navigation.service';
import { EFeatureFlags } from '@app/shared/enums/feature-flag';
import { mixpanelEventTypes } from '@app/shared/enums/mixpanel.enum';
import { FeatureFlagService } from '@app/shared/services/feature-flag/feature-flag.service';
import { MixpanelService } from '@app/shared/services/mixpanel/mixpanel.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cm-menu-navigation-item',
  templateUrl: './menu-navigation-item.component.html',
  styleUrls: ['./menu-navigation-item.component.scss'],
})
@UntilDestroy()
export class MenuNavigationItemComponent implements OnInit {
  @Input() navigationSection: INavigationSection;
  @Input() navigationItem: INavigationItem;
  @Input() favoriteIcon: boolean;
  @Input() isChild: boolean;
  @Input() disableFavorite: boolean;
  @Input() sectionChild: boolean;
  @Input() sectionChildFavorite: boolean;
  @Input() selectedSectionValue: string;

  selectedSection: string;
  isExpanded: boolean;

  constructor(
    private mixpanelService: MixpanelService,
    private navigationService: NavigationService,
    private translateService: TranslateService,
    private featureFlagService: FeatureFlagService
  ) {}

  ngOnInit(): void {
    this.navigationService.selectedSection$.pipe(untilDestroyed(this)).subscribe((selectedSection) => {
      this.selectedSection = selectedSection;
    });
  }

  get isShrinked() {
    return this.navigationService.isShrinked;
  }

  onExpand() {
    this.isExpanded = !this.isExpanded;
  }

  onFavoriteToggle($event) {
    this.navigationItem.isMarkedAsFavorite = !this.navigationItem.isMarkedAsFavorite;
    this.navigationService.saveFavorite(this.navigationItem);

    if (this.navigationItem.isMarkedAsFavorite) {
      this.mixpanelService.trackEvent(mixpanelEventTypes.SIDEBAR_ADD_FAVORTIE, {
        addFavorite: this.navigationItem.routerLink,
      });
    }
    $event.stopPropagation();
  }

  get favoriteTooltipText() {
    return this.translateService.instant(
      this.navigationItem.isMarkedAsFavorite ? 'navigation.remove-from-favorites' : 'navigation.add-to-favorites'
    );
  }

  trackNavigateEvent(navigationItem: INavigationItem): void {
    this.mixpanelService.trackEvent(mixpanelEventTypes.SIDEBAR_NAVIGATE, {
      navigateTo: navigationItem.routerLink,
    });
  }

  public checkFeatureFlagStrategy(featureFlagModule: EFeatureFlags): boolean {
    return featureFlagModule ? this.featureFlagService.evaluate(featureFlagModule) : true;
  }
}
